import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useWallet } from '~/wallet';

export const RootRedirect = observer(() => {
  const { identity } = useWallet();
  return <Navigate to={identity.isAuthenticated ? '/account' : '/login'} replace />;
});
